import { render, staticRenderFns } from "./ImageFileInput.vue?vue&type=template&id=c381acfe&scoped=true&"
import script from "./ImageFileInput.vue?vue&type=script&setup=true&lang=js&"
export * from "./ImageFileInput.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ImageFileInput.vue?vue&type=style&index=0&id=c381acfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c381acfe",
  null
  
)

export default component.exports